import React from "react";
import {
    BooleanInput,
    Datagrid,
    DateField, Filter,
    List, SelectInput,
    SimpleShowLayout,
    TextField, TextInput,
    UrlField,
} from "react-admin";
import ShowView from "../../components/ShowView";
import {AttachmentFilterType} from "./attachmentConstant";

const AttachmentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="شناسه" source="objectId"/>
        <SelectInput
            label="نوع"
            choices={AttachmentFilterType}
            optionText={"name"}
            optionValue={"value"}
            source={"fileType"}
            alwaysOn
        />
        <TextInput label="آدرس" source="url"/>
        <TextInput label="اسم" source="fileName"/>
    </Filter>
);

export const AttachmentList = (props) => (
  <List {...props} perPage={20} filters={<AttachmentFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
      <UrlField source="url"/>
        <TextField source="fileType"/>
        <TextField source="fileName"/>
        <TextField source="fileSize"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const AttachmentShow = (props) => (
  <ShowView {...props} noEdit={true} noDel={true}>
    <SimpleShowLayout>
      <TextField source="objectId"/>
      <UrlField source="url"/>
        <TextField source="fileType"/>
        <TextField source="fileName"/>
        <TextField source="fileSize"/>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);

